import { Bike } from "lucide-react";

export const EmployeeRentedSection = ({ rented }) => {
  const list = Object.entries(rented || {});
  if (!list.length) return null;
  return (
    <div className="mt-4 rounded-2xl border border-violet-200 bg-violet-50/40 p-3" data-testid="emp-rented-section">
      <p className="mb-2 flex items-center gap-1.5 text-sm font-bold text-violet-800"><Bike className="h-4 w-4" /> حسابات مستأجرة (فري لانسر)</p>
      <div className="grid gap-2 sm:grid-cols-2">
        {list.map(([p, r]) => (
          <div key={p} className="rounded-xl bg-white p-2.5 text-xs text-slate-600 space-y-0.5" data-testid={`emp-rented-${p}`}>
            <p className="font-bold text-violet-700">{p}</p>
            <p>صاحب الحساب: <b className="text-slate-800">{r.owner_name || "—"}</b>{r.owner_id ? ` · معرّف ${r.owner_id}` : ""}</p>
            {r.owner_national_id && <p>الهوية: <span dir="ltr">{r.owner_national_id}</span></p>}
            {r.owner_phone && <p>الجوال: <span dir="ltr">{r.owner_phone}</span></p>}
            {r.owner_iban && <p>{r.owner_bank ? `${r.owner_bank} · ` : ""}<span dir="ltr" className="font-mono">{r.owner_iban}</span></p>}
            {r.rent && <p>الإيجار: {r.rent} ر.س شهرياً</p>}
            {r.moto_plate && <p>الدباب: {r.moto_plate}</p>}
            {(r.since || r.handed_at) && <p>استلام {r.since || "—"} · تسليم {r.handed_at || "—"}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};
